import { call, put, select } from 'redux-saga/effects';

import * as types from './settings.types';
import * as actions from './settings.actions';

import * as api from '../../api/request-config/settings.api';

import { apiRequest } from '../../api/api.saga-services';
import { settingsSelectors } from './settings.selectors';
import { formSelectors } from '../../page/page-storage/users/user-form/user-form.selectors';
import { addFlashMessage } from '../../../utils/flashMessages.utils';
import Cookies from 'js-cookie';

export function* storeSettings(settings: types.ISettings) {
  yield put(actions.storeSettings(settings));
}

export function* clearSettings(settingsId: types.ISettings['id']) {
  yield put(actions.clearSettings(settingsId));
}

export function* clearAllSettings() {
  const settingsIds: types.ISettings['id'][] = yield select(settingsSelectors.selectResourceIds);
  yield put(actions.clearSettings(settingsIds));
}

export function* searchSettings() {
  const settings: types.ISettings = yield call(apiRequest, api.searchSettingsApi());
  yield call(storeSettings, settings);
}

export function* updateSettings(settingsUpdate: types.ISettingsUpdate) {
  const allSettings: types.ISettings[] = (yield select(settingsSelectors.selectResourceList)) as types.ISettings[];
  const settings: types.ISettings = allSettings.find((s) => s !== null) as types.ISettings;
  const iconLogoData = (yield select(formSelectors.selectFormAvatar)) as string;
  const dashboardLogoData = (yield select(formSelectors.selectFormFile)) as string;

  const updatedSettings: types.ISettingsUpdate = { id: settings.id, ...settingsUpdate };
  updatedSettings.iconLogo = iconLogoData;
  updatedSettings.dashboardLogo = dashboardLogoData;

  const settingsResponse = yield call(apiRequest, api.saveSettingsApi(updatedSettings));
  yield call(storeSettings, settingsResponse);

  addFlashMessage({
    type: 'success',
    message: 'Settings have been saved!',
  });

  if (settingsResponse.primaryColor1 && settingsResponse.primaryColor1 !== '') {
    yield call([Cookies, Cookies.set], 'color_theme', settingsResponse.primaryColor1);
  } else {
    yield call([Cookies, Cookies.remove], 'color_theme');
  }
}

export function* resetPrimaryColors() {
  const allSettings: types.ISettings[] = (yield select(settingsSelectors.selectResourceList)) as types.ISettings[];
  const settings: types.ISettings = allSettings.find((s) => s !== null) as types.ISettings;
  const updatedSettings: types.IResetPrimaryColors = {
    id: settings.id,
    primaryColor1: '',
    primaryColor2: '',
    primaryColor3: '',
    primaryColor4: '',
  };
  const settingsResponse = yield call(apiRequest, api.resetSettingsColorsApi(updatedSettings));
  yield call(storeSettings, settingsResponse);
}

export function* resetSecondaryColors() {
  const allSettings: types.ISettings[] = (yield select(settingsSelectors.selectResourceList)) as types.ISettings[];
  const settings: types.ISettings = allSettings.find((s) => s !== null) as types.ISettings;
  const updatedSettings: types.IResetSecondaryColors = {
    id: settings.id,
    secondaryColor1: '',
    secondaryColor2: '',
    secondaryColor3: '',
    secondaryColor4: '',
  };
  const settingsResponse = yield call(apiRequest, api.resetSettingsColorsApi(updatedSettings));
  yield call(storeSettings, settingsResponse);
}
